import type { FC } from 'react';
import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData, graphql } from '@packages/gql/generated/shopping';
import { CategoryFilterStandalone } from '../CategoryFilterStandalone';
import { useSearchResultDataForCategoryFilter } from './useSearchResultDataForCategoryFilter';

export const SearchResultCategoryFilterFragment = graphql(/* GraphQL */ `
  fragment SearchResultCategoryFilterFragment on SuccessfulSearchResult {
    ...UseSearchResultDataForCategoryFilterFragment
  }
`);

export type SearchResultCategoryFilterProps = {
  maskedData: FragmentType<typeof SearchResultCategoryFilterFragment>;
  /** If `true`, shows a dedicated "clear all" interaction/button in addition to the root level category */
  showClearAll?: boolean;
  /** Callback fired when a category is clicked or all categories are cleared */
  onNavigate?: () => void;
};

/**
 * Formats SERP category navigation items to be used in CategoryFilterStandalone component
 * */
export const SearchResultCategoryFilter: FC<SearchResultCategoryFilterProps> = ({
  maskedData,
  showClearAll,
  onNavigate,
}) => {
  const data = getFragmentData(SearchResultCategoryFilterFragment, maskedData);

  const items = useSearchResultDataForCategoryFilter(data);

  return (
    <CategoryFilterStandalone
      categories={items}
      showClearAll={showClearAll}
      onNavigate={onNavigate}
    />
  );
};
